export default __webpack_public_path__ + "static/fergus-6ccabea1d433b71236831f23fb650701.jpeg";